import { baseUniDriverFactory } from '../test-utils/utils/unidriver';

export const mobilePreviewWidgetDriverFactory = base => {
  return {
    ...baseUniDriverFactory(base),
  };
};
